"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.kinds = exports.entityTypes = void 0;
var entityTypes = {
  person: 'person',
  organization: 'organization'
};
exports.entityTypes = entityTypes;
var kinds = {
  primary: 'primary',
  secondary: 'secondary'
};
exports.kinds = kinds;
var sizes = {
  medium: 'medium',
  large: 'large'
};
exports.sizes = sizes;